<template>
  <div>
    <div v-for="(platform, key) in item" :key="key">{{ platforms[key]?.text || key }}: {{ platform.sku }}</div>
  </div>
</template>

<script>
import BodyDefault from '@/components/TableList/Cols/BodyDefault.vue'

export default {
  extends: BodyDefault,
  computed: {
    item() {
      return this.row[this.config?.key] || {}
    },
    screenOptions() {
      return this.config?.extraAttributes || {}
    },
    platforms() {
      return this.screenOptions?.platforms || {}
    }
  },
  methods: {}
}
</script>
